import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { UserType } from "types/UsersTypes";
import { useLogout } from "hooks/auth/";

export function useGetMe() {
  const { mutate: logout } = useLogout({});
  
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      if (!navigator.onLine) {
        try {
          const cached = localStorage.getItem('offlineApiCache');
          if (cached) {
            const cacheData = JSON.parse(cached);
            const userCache = cacheData['users/me'];
            if (userCache) {
              return userCache.data;
            }
          }
          const userData = localStorage.getItem('userData');
          if (userData) {
            const parsedUser = JSON.parse(userData);
            return { user: parsedUser, status: 'success' };
          }
          throw new Error('No offline data available');
        } catch (error) {
          throw error;
        }
      }
      try {
        const response = await axiosInstance.get("/users/me");
        if (response.data && navigator.onLine) {
          try {
            localStorage.setItem('userData', JSON.stringify(response.data.user));
          } catch (error) {
            console.error('Error saving user data to localStorage:', error);
          }
        }
        
        return response.data;
      } catch (firstError) {
        try {
          const response = await axiosInstance.get("/users/me");
          
          if (response.data && navigator.onLine) {
            try {
              localStorage.setItem('userData', JSON.stringify(response.data.user));
            } catch (error) {
              console.error('Error saving user data to localStorage:', error);
            }
          }
          
          return response.data;
        } catch (secondError) {
          if (navigator.onLine && window.location.href.includes('dashboard')) {
            setTimeout(() => logout(), 100);
          }
          throw secondError; 
        }
      }
    },
    select: (data: { user: UserType }) => data.user,
    retry: (failureCount, error: any) => {
      if (!navigator.onLine) {
        return false;
      }
      return false;
    },
    staleTime: 0,
    gcTime: 0,
  });
}